(function (root, factory) {

    var pluginName = 'PearsonAccordion';

    if (typeof define === 'function' && define.amd) {
        define([], factory(pluginName));
    } else if (typeof exports === 'object') {
        module.exports = factory(pluginName);
    } else {
        root[pluginName] = factory(pluginName);
    }
}(this, function (pluginName) {

    'use strict';

    var defaults = {
        componentClass: '',
        toggleClass: '',
        showListClass: '',
        listClass: ''
    };
    /**
     * Merge defaults with user options
     * @param {Object} defaults Default settings
     * @param {Object} options User options
     */
    var extend = function (target, options) {
        var prop,
            extended = {};
        for (prop in defaults) {
            if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
                extended[prop] = defaults[prop];
            }
        }
        for (prop in options) {
            if (Object.prototype.hasOwnProperty.call(options, prop)) {
                extended[prop] = options[prop];
            }
        }
        return extended;
    };

    /**
     * DOM Elements validation
     @private
     @param {Object} options User options
     @returns {Boolean} true if all required DOM elements are present
     */
    var checkForRequredDOMElements = function (options) {
        var accordion = document.querySelector(options.componentClass);
        // Check if accordion component DOM element is present
        if (!accordion) {
            return false;
        }
        return true;
    };

    /**
     * Get the natural height of the element
     * @param {DOMNode} elem list of accordion buttons or pricing items
     * @param {number} height - height of element
     * @function
     */
    var getHeight = function (elem, height) {
        elem.style.display = 'block'; // Make it visible
        height = elem.scrollHeight + 'px'; // Get it's height
        elem.style.display = ''; //  Hide it again
        return height;
    };

    /**
     * Show list of accordion buttons or pricing items
     * @param {DOMNode} elem list of accordion buttons or pricing items
     * @param {Object} options User options
     * @function
     */
    var show = function (elem, options, btn) {
        var height = getHeight(elem, height); // Get the natural height
        elem.classList.add(options.toggleClass); // Make the element visible
        elem.style.height = height; // Update the max-height
        // Once the transition is complete, remove the inline max-height so the content can scale responsively
        window.setTimeout(function () {
            elem.style.height = '';
            // Sets "aria-expanded" to true for accordion buttons
            btn.setAttribute('aria-expanded', 'true');
        }, 350);
    };

    /**
     * Hide list of accordion buttons or pricing items
     * @param {DOMNode} elem list of accordion buttons or pricing items
     * @param {Object} options User options
     * @function
     */
    var hide = function (elem, options, btn) {
        // Give the element a height to change from
        elem.style.height = elem.scrollHeight + 'px';
        // Set the height back to 0
        window.setTimeout(function () {
            elem.style.height = '0';
        }, 0);
        // When the transition is complete, hide it
        window.setTimeout(function () {
            elem.classList.remove(options.toggleClass);
            // Sets "aria-expanded" to false for accordion buttons
            btn.setAttribute('aria-expanded', 'false');
        }, 350);
    };

    /**
     * Toggle element visibility
     * @param {DOMNode} elem list of accordion buttons or pricing items
     * @param {Object} options User options
     * @param {function} showFunction show list of accordion buttons or pricing items
     * @param {function} hideFunction hide list of accordion buttons or pricing items
     * @function
     */
    var toggleVisibility = function (elem, options, showFunction, hideFunction, btn) {
        // If the element is visible, hide it
        if (elem.classList.contains(options.toggleClass)) {
            hideFunction(elem, options, btn);
            return;
        }
        // Otherwise, show it
        showFunction(elem, options, btn);
    };

    /**
     * Toggle accordion button
     * @param {Object} options User options
     * @function
     */
    var accordionStateChange = function (options) {
        var accordion = document.querySelector(options.componentClass);
        if (!accordion) return;
        // Collect all accordion buttons
        var toggleElement = accordion.getElementsByClassName(options.showListClass);
        [].forEach.call(toggleElement, function (element) {
            setAriaControlsAttribute(element);
            // Sets "aria-expanded" to true/false for accordion buttons
            element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') === 'true' ? 'true' : 'false');
            element.addEventListener('click', function (e) {
                // Sets accoridon buttons to active/notActive
                this.classList.toggle(options.toggleClass);
                // Toggle accordion button
                toggleVisibility(this.nextElementSibling, options, show, hide, this);
            }, false);
        });
    };

    var setAriaControlsAttribute = function (btn) {
        const panelId = btn.nextElementSibling.getAttribute('id');

        btn.setAttribute('aria-controls', panelId);
    };

    /**
     * Plugin Object
     * @param {Object} options User options
     * @constructor
     */
    function Plugin(options) {
        this.options = extend(defaults, options);

        this.init();
    }

    /**
     * Plugin prototype
     * @public
     * @constructor
     */
    Plugin.prototype = {
        init: function () {
            if (checkForRequredDOMElements) {
                // Toggle
                accordionStateChange(this.options);
            }
        }
    };
    return Plugin;
}));
